module.exports = __webpack_public_path__ + "calltracking-thinking.6fcdb1c3855d8c66908ca5bfebef03bc.png";